import React from 'react';
import { Plus } from 'lucide-react';
import { desktopRibbonCtaButtonClass } from '../../../components/ribbon/DesktopRibbonControls';

/** Classe padrão dos filtros no ribbon de Administração. */
export const adminRibbonFilterBtnClass =
  'flex h-[30px] shrink-0 items-center gap-1.5 rounded-[3px] border border-[var(--border-default)] bg-[var(--bg-surface)] px-2 text-[12px] text-[var(--text-primary)] transition-colors hover:bg-[var(--button-hover)]';

interface AdminRibbonCtaButtonProps {
  label: string;
  onClick: () => void;
  title?: string;
  disabled?: boolean;
}

/** Botão azul de cadastro no ribbon — à esquerda dos filtros (ícone + único). */
export const AdminRibbonCtaButton: React.FC<AdminRibbonCtaButtonProps> = ({
  label,
  onClick,
  title,
  disabled = false,
}) => (
  <button
    type="button"
    className={desktopRibbonCtaButtonClass}
    title={title ?? label}
    disabled={disabled}
    onClick={onClick}
  >
    <Plus size={14} strokeWidth={2} className="shrink-0" />
    <span>{label}</span>
  </button>
);
